import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrder, SearchQueryOrderDirection } from "types/generated";

export enum SPACE_CONTEXTS_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  INHERITED_FROM = "INHERITED_FROM",
}

export const SPACE_CONTEXTS_COLUMNS_STORAGE_KEY = "spaceDetailsContextsColumnsConfig";
export const SPACE_CONTEXTS_LIMIT_STORAGE_KEY = "spaceDetailsContextsLimit";
export const SPACE_CONTEXTS_FILTERS_ORDER_KEY = "spaceDetailsContextsFiltersOrder";
export const SPACE_CONTEXTS_INITIAL_LIMIT = 50;

export const SPACE_CONTEXTS_COLUMN_CONFIG: Record<SPACE_CONTEXTS_COLUMN_ID, TableColumnMeta> = {
  [SPACE_CONTEXTS_COLUMN_ID.NAME]: {
    id: SPACE_CONTEXTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_CONTEXTS_COLUMN_ID.DESCRIPTION]: {
    id: SPACE_CONTEXTS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: 2000,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_CONTEXTS_COLUMN_ID.INHERITED_FROM]: {
    id: SPACE_CONTEXTS_COLUMN_ID.INHERITED_FROM,
    title: "Inherited from",
    tooltip: "Shows if a context lives in this space or is inherited from a parent space.",
    minWidth: 200,
    defaultWidth: 250,
    maxWidth: 400,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
};

export const SPACE_CONTEXTS_SORT_CONFIG: Record<string, string> = {
  [SPACE_CONTEXTS_COLUMN_ID.NAME]: "name",
};

export const SPACE_CONTEXTS_INITIAL_ORDER_BY: SearchQueryOrder = {
  field: SPACE_CONTEXTS_SORT_CONFIG[SPACE_CONTEXTS_COLUMN_ID.NAME],
  direction: SearchQueryOrderDirection.Asc,
};
